<template>
    <v-container fluid class="page-container">
        <page-header title="Offers" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New offer
            </v-btn>
        </page-header>

        <filter-panel
            :fields="filterFields"
            :value="listState"
            :loading="loading"
            @apply="applyFilters"
        />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No offers match these filters"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.partner`]="{ item }">
                    <span class="font-weight-medium">{{ item.partner ? item.partner.title : '—' }}</span>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                    <div class="description">{{ item.description }}</div>
                </template>
                <template v-slot:[`item.expirationDate`]="{ item }">
                    <span :class="{ 'error--text': isExpired(item.expirationDate) }">{{ formatDate(item.expirationDate) }}</span>
                </template>
                <template v-slot:[`item.active`]="{ item }">
                    <v-chip small :outlined="!item.active" :color="item.active ? 'success' : 'grey'">
                        {{ item.active ? 'Active' : 'Inactive' }}
                    </v-chip>
                    <v-chip v-if="item.secret" x-small outlined class="ml-1">Secret</v-chip>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button title="Delete this offer?" @delete-entry="deleteItem(item, deleteOffer, 'Offer')" />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import moment from 'moment'
    import offerService from '@/services/offer-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'
    import { formatDate } from '@/utils/format'

    export default {
        name: 'OfferRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                offerTypes: null,
                headers: [
                    { text: 'Partner', value: 'partner' },
                    { text: 'Description', value: 'description' },
                    { text: 'Type', value: 'type' },
                    { text: 'Expires', value: 'expirationDate' },
                    { text: 'Status', value: 'active' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        computed: {
            filterFields() {
                return [
                    { key: 'partner', label: 'Partner', placeholder: 'Title or id' },
                    { key: 'type', label: 'Type', type: 'autocomplete', items: this.offerTypes },
                    { key: 'active', label: 'Active', type: 'boolean' },
                    { key: 'secret', label: 'Secret', type: 'boolean' }
                ]
            }
        },
        created() {
            offerService.getOfferTypes().then(resp => {
                this.offerTypes = (resp.data || []).map(row => row.type).filter(Boolean)
            }).catch(() => {
                this.offerTypes = []
            })
        },
        methods: {
            formatDate,
            fetchPage({ page, perPage, filters, sortOption, order }) {
                return offerService.getOffersByFilter(page, filters, sortOption, order, perPage)
            },
            deleteOffer: id => offerService.deleteOfferById(id),
            isExpired(date) {
                return !!date && moment(date).isBefore(moment(), 'day')
            }
        }
    }
</script>

<style scoped>
.description {
    max-width: 380px;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
